if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const previousEventWarning = this.querySelector('[data-event-cart-warning]');
        if (previousEventWarning) {
          previousEventWarning.hidden = true;
          previousEventWarning.textContent = '';
        }

        let savedEvent = null;
        try {
          savedEvent = JSON.parse(sessionStorage.getItem('ylicool:selected-event:v1') || 'null');
        } catch (error) {
          console.warn('Event context could not be read.', error);
        }
        const metaData = window.collectionMeta || savedEvent;
        const eventContext = ['654111146320', '654111015248'].includes(String(metaData?.id))
          ? metaData
          : null;
        const currentTime = new Date();
        const validUntil = new Date(metaData?.endDate);

        if (validUntil && currentTime > validUntil) {
          this.toggleSubmitButton(true, "Ettetellimine lõppenud");
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (eventContext) {
          formData.set('properties[_event_id]', String(eventContext.id));
          formData.set('properties[_event_name]', eventContext.title);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        Promise.resolve()
          .then(async () => {
            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              headers: { Accept: 'application/json' },
              cache: 'no-store',
            });
            if (!cartResponse.ok) throw new Error('Ostukorvi kontroll ebaõnnestus. Palun proovige uuesti.');
            const currentCart = await cartResponse.json();
            if (!Array.isArray(currentCart.items)) throw new Error('Ostukorvi kontroll ebaõnnestus.');
            const hasConflict = currentCart.items.some((item) => {
              const itemEventId = String(item.properties?._event_id || '');
              if (eventContext) return itemEventId !== String(eventContext.id);
              return itemEventId !== '';
            });
            if (hasConflict) {
              throw new Error('Ostukorvis on teise ürituse või ürituseta tooteid. Vormistage need eraldi tellimusena või tühjendage ostukorv enne ürituse vahetamist.');
            }
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            const message = e.message || window.cartStrings.error;
            this.handleErrorMessage(message);
            // Quick-add cards can hide the theme's standard error area.
            let eventWarning = this.querySelector('[data-event-cart-warning]');
            if (!eventWarning) {
              eventWarning = document.createElement('p');
              eventWarning.setAttribute('data-event-cart-warning', '');
              eventWarning.setAttribute('role', 'alert');
              eventWarning.setAttribute('tabindex', '-1');
              eventWarning.style.cssText = 'display:block;width:100%;margin:12px 0;padding:12px;border:1px solid currentColor;font-size:14px;line-height:1.5;';
              this.form.insertAdjacentElement('afterend', eventWarning);
            }
            eventWarning.textContent = message;
            eventWarning.hidden = false;
            eventWarning.focus();
            eventWarning.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

    }
  );
}